import { useEffect } from 'react'

const CHAT_STYLES = isPromoActive =>
  `#chat-window {
    margin-bottom: 4.5rem;
  }
  @media (max-width: 1240px) {
    #chat-window {
      margin-bottom: ${isPromoActive ? '8rem' : '4.5rem'};
    }
  }`

const createStyleSheet = async isPromoActive => {
  const styleSheet = new CSSStyleSheet()
  await styleSheet.replace(CHAT_STYLES(isPromoActive))
  return styleSheet
}

const applyStyling = async (element, isPromoActive) => {
  await customElements.whenDefined('alby-chatbot')
  const shadowRoot = element?.shadowRoot

  if (shadowRoot?.adoptedStyleSheets) {
    const styleSheet = await createStyleSheet(isPromoActive)
    shadowRoot.adoptedStyleSheets = [
      ...shadowRoot.adoptedStyleSheets,
      styleSheet
    ]
  }
}

// We do not have the ability to apply custom style rules to the ai chat window in the Alby UI
// Access the shadowRoot elements and apply custom styling
export const useAIChatStyleSheet = (chatbotRef, isPromoActive) => {
  useEffect(() => {
    if (chatbotRef.current) {
      applyStyling(chatbotRef.current, isPromoActive).catch(console.error)
    }
  }, [chatbotRef, isPromoActive])
}
